/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";
import Form from "../../components/Form";
import Modal, { ModalHeader } from "../../components/Modal";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { ANONYMOUS, SECRET, COMMUNITY_TAX_MANAGER_LIST, COMMUNITY_ALARM_LIST } from "../../constants/COMMUNITY";
import { addCommunity, putCommunity } from "../../apis/community/community";
// import useForm from "../../hooks/useForm";
import { toast } from "../../utils/toast";

const DetailCommunity = (props) => {
  const { selectedCommunity, open, setOpen, setSelectedCommunity, submit, permission, employee } = props
  const [mode, setMode] = useState('create')
  const [fields] = useState([
    [
      {
        title: "게시판명", key: "title", type: "input", required: true,
      },
    ],
    [
      {
        title: "설명", key: "description", type: "input", required: true,
      },
    ],
    [
      {
        title: "실명/익명",
        key: "isAnonymous",
        type: "radio",
        options: {
          list: ANONYMOUS,
        },
        required: true,
      },
    ],
    [
      {
        title: "공개여부",
        key: "isSecret",
        type: "radio",
        options: {
          list: SECRET,
        },
        required: true,
      },
    ],
    [
      {
        title: "게시판 관리자",
        key: "adminEmployees",
        type: "searchemployees",
        required: true,
      },
      {
        isHide: ({ form }) => { // 항상 안보임. 디자인 맞추기 위한 용도
          return form.isSecret !== '999999'
        },
      },
    ],
    [
      {
        isHide: ({ form }) => {
          return form.isSecret === '0'
        },
        title: "이용자 선택",
        key: "accessEmployees",
        type: "searchemployees",
      },
      {
        isHide: ({ form }) => {
          return form.isSecret === '1'
        },
        className: 'first',
        title: "이용자 선택",
        onValue: () => '전체 임직원 이용 가능'
      },
    ],
    [
      {
        isHide: ({form}) => {
          return form.mode === 'view'
        },
        title: "세무 담당자",
        key: "isManager",
        type: "select",
        options: {
          list: COMMUNITY_TAX_MANAGER_LIST,
        },
      },
      {
        isHide: ({form}) => {
          return form.mode !== 'view'
        },
        title: "세무 담당자",
        onValue: () => {
          const data = COMMUNITY_TAX_MANAGER_LIST.find(e => e.value === form.isManager)
          return data.label
        },
      },
    ],
    [
      {
        isHide: ({form}) => {
          return form.mode === 'view'
        },
        title: "알림 설정",
        key: "alarmLevel",
        type: "select",
        options: {
          list: COMMUNITY_ALARM_LIST,
        },
      },
      {
        isHide: ({form}) => {
          return form.mode !== 'view'
        },
        title: "알림 설정",
        onValue: () => {
          const data = COMMUNITY_ALARM_LIST.find(e => e.value === form.alarmLevel)
          return data.label
        }
      },
    ],
  ]);

  const defaultForm = {
    title: "",// 게시판 이름
    description: "", // 게시판명
    isAnonymous: ANONYMOUS[0].value, // 0: 실명 1: 익명
    isSecret: SECRET[0].value, // 0: 공개 1: 비공개
    accessEmployees: [],
    adminEmployees: [],
    isManager: 0,
    alarmLevel: 0,
    // 매니저 사용자 추가
  }

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (mode !== 'create') {
      setSelectedCommunity(null)
    }
  };

  const _submit = ({ accessEmployees, adminEmployees, ..._form }) => {

    const form = {
      //..._form,
      title: _form.title,
      description: _form.description,
      isAnonymous: _form.isAnonymous === "1",
      isSecret: _form.isSecret === "1",
      accessEmployeesIdxes: accessEmployees.map(e => e.idx),
      adminEmployeesIdxes: adminEmployees.map(e => e.idx),
      isManager: _form.isManager,
      alarmLevel: _form.alarmLevel,
    }
    
    if (form.isSecret && isEmpty(form.accessEmployeesIdxes)) {
      return toast.error("비공개 선택시 이용자 선택은 필수입니다.");
    }
    if (!form.isSecret) {
      form.accessEmployeesIdxes = []
    }

    if (mode === 'create') {
      systemAlert(`"${form.title}" 게시판을 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              addCommunity(form)
                .then(() => {
                  cancel()
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    } else {
      systemAlert(`"${form.title}" 게시판을 수정하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              putCommunity(selectedCommunity.idx, form)
                .then(() => {
                  cancel()
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    }
  }

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    
    // setFormFields(task.fields)
    // debugger
    if (selectedCommunity) {
      //console.log("selectedCommunity: ", selectedCommunity)

      const form = {
        ...selectedCommunity,
        isAnonymous: selectedCommunity.isAnonymous ? "1" : "0",
        isSecret: selectedCommunity.isSecret ? "1" : "0",
        accessEmployees: selectedCommunity.employees.filter(e => e.level < 9),
        adminEmployees: selectedCommunity.employees.filter(e => e.level >= 9),
        isManager: selectedCommunity.isManager,
        alarmLevel: selectedCommunity.alarmLevel,
      }

      

      const isAdmin = selectedCommunity.employees.find(e => e.idx === employee.idx && e.level >= 9)
      form.mode = isEmpty(selectedCommunity) ? 'create' : (permission.level >= 2 || !isEmpty(isAdmin) ? 'modify' : 'view')
      setMode(form.mode)
      
      setForm(form)
      setOriginForm(form)
    } else {
      setForm(defaultForm)
      setOriginForm(defaultForm)
    }
  }, [open, selectedCommunity])

  useEffect(() => {
    setValidateFields(fields)
  }, [fields])

  return (
    <Modal
      isOpen={open}
      // isOpen={true}
      close={cancel}
    // {...mode === 'create' ? { close: cancel } : { toggle: cancel }}
    >
      <div className="client-write">
        <ModalHeader>{selectedCommunity ? <>{selectedCommunity.title} {mode === 'modify' ? " 수정" : ""} </> : '게시판 생성'} </ModalHeader>
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '생성하기' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default DetailCommunity;
